import * as Styled from "./CatalogList.styled"

export function CatalogListError(props) {

    const { errorText, ...otherProps } = props

    return <div {...otherProps}>
        <Styled.ErrorTitle>{errorText}</Styled.ErrorTitle>
    </div>
}